import { css } from "@emotion/react";

export const header = css`
  text-align: center;
`;

export const title = css`
  margin-bottom: 28px;
`;
